<template>
    <NuxtLink
        v-editable="button"
        :to="isActive ? url : undefined"
        :target="button.link?.target"
        class="btn mb-3 w-full text-center md:mb-0 md:w-auto"
        :class="'btn-' + button.style"
        >{{ button.label }}</NuxtLink
    >
</template>

<script setup lang="ts">
import type { Button } from '#shared/types/storyblok/Button';
import { urlFromStoryblokLinkField } from '~/utils/helpers';

const props = withDefaults(
    defineProps<{
        button: Button;
        isActive?: boolean;
    }>(),
    {
        isActive: true,
    },
);

const url = computed(() => urlFromStoryblokLinkField(props.button.link));
</script>
